export default __webpack_public_path__ + "static/wave_header-0e6cf7577e3ce41789d3af797e6c1494.png";